import { $, type Properties, resolve } from "signlets";

import { feetPerMeter } from "../constants";
import { groundDistance } from "../math";
import type { Vehicle } from "../vehicle";
import { Message } from "./Message";

export type DropResultsProps = {
  visible: boolean;
  vehicle?: Vehicle;
};

export const DropResults = ({
  visible,
  vehicle,
}: Properties<DropResultsProps>) => {
  const state = $(() => resolve(vehicle)?.state());

  const flying = $(() => state()?.flying && (state()?.bootTime ?? 0) > 10000);
  const position = $(() => state()?.position);
  const latitude = $(() => {
    const [, latitude] = position() ?? [];
    return latitude;
  });
  const longitude = $(() => {
    const [longitude] = position() ?? [];
    return longitude;
  });

  const target = $(() => state()?.target);

  return (
    <Message visible={$(() => resolve(visible) && !flying() && !!target())}>
      Land position: {$(() => latitude()?.toFixed(4))},{" "}
      {$(() => longitude()?.toFixed(4))}
      <br />
      Distance from target:{" "}
      {$(() =>
        Math.round(
          groundDistance(position() ?? [0, 0, 0], target() ?? [0, 0, 0]) *
            feetPerMeter,
        ),
      )}
      ft
    </Message>
  );
};
